<template>
<div>
    <el-row>
        <el-col :lg="10" :offset="2">
            店櫃: {{this.shops.name}}
        </el-col>
        <el-col :lg="10" :offset="2">
            美容師: {{this.userInfo.name}}
        </el-col>
    </el-row>
    <el-row>
        <el-col :lg="10" :offset="2">
            
            品牌: {{this.memberInfo.brand_id == 1 ? 'N牌': 'S牌'}}
        </el-col>
        <el-col :lg="10" :offset="2">
            會員名字: {{this.getMemberDetail.name}}
        </el-col>
    </el-row>
    <el-row>
        <el-col :lg="10" :offset="2">
            生日: {{this.getMemberDetail.birthday}}
        </el-col>
        <el-col :lg="10" :offset="2">
            性別: {{this.sex}}
        </el-col>
    </el-row>
    <el-row>
        <el-col :lg="10" :offset="2">
            郵遞區號: {{this.getMemberDetail.postcode}}
        </el-col>
        <el-col :lg="10" :offset="2">
            地址: {{this.getMemberDetail.city}}{{this.getMemberDetail.area}}{{this.getMemberDetail.address}}
        </el-col>
    </el-row>
    <el-row>
        <el-col :lg="10" :offset="2">
            手機: {{this.getMemberDetail.phone}}
        </el-col>
        <el-col :lg="10" :offset="2">
            膚質: {{this.getMemberDetail.skin}}
        </el-col>
    </el-row>
    <el-row>
        <el-col :lg="10" :offset="2">
            EMAIL: {{this.getMemberDetail.email}}
        </el-col>
        <el-col :lg="10" :offset="2">
            電子錢包額度: {{this.getMemberDetail.e_pay}}
        </el-col>
    </el-row>
    <el-row>
        <el-col :lg="10" :offset="2">紅利點數: {{this.getMemberDetail.point}}</el-col>
        <el-col :lg="10" :offset="2">
            累積金額: {{this.getMemberDetail.consumption}}
        </el-col>
    </el-row>
    <el-row>
        <el-col :lg="10" :offset="2">
            婚姻狀態: {{this.mar}}
        </el-col>
        <el-col :lg="10" :offset="2">
            推薦人: {{this.getMemberDetail.referrer}}
        </el-col>
    </el-row>
    <el-row>
        <el-col :lg="10" :offset="2">
            <el-button type="primary" @click="editTabs">編輯</el-button>
            <el-button type="default" @click="changeBack">返回</el-button>
        </el-col>
        <el-col :lg="10" :offset="2"></el-col>
    </el-row>

</div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from 'vuex'

export default {
    name: 'Detail',
    props: {
        memberKey: String
    },
    data() {
        return {
            memberInfo: null,
            shops: {},
            beauticians: [],
            userInfo: [],
            sales: [],
            couponInfo: [],
            mar: '',
            brand: '',
            sex: ''
        }
    },
    computed: mapGetters(["getMemberDetail", "getShopDetail", "  beauticiansItems", "salesItems", "UserInfo", "getMemberCoupon"]),
    methods: {
        ...mapActions(["fetchMemberDetail", "fetchShopDetail", "fetchUserDetail"]),
        fetch: async function () {
            const data = await {
                _key: this.memberKey
            }
            await this.$store.dispatch('fetchMemberDetail', data)
            this.memberInfo = await this.getMemberDetail

            if (this.getMemberDetail.sex == 1) {
                this.sex = '女'
            } else {
                this.sex = '男'
            }
            if (this.getMemberDetail.married == 1) {
                this.mar = '未婚'
            } else if (this.getMemberDetail.married == 2) {
                this.mar = '已婚'
            } else {
                this.mar = '其他'
            }
            await this.fetchShops(this.memberInfo.shop_key)
            await this.fetchUser(this.memberInfo.user_key)

        },
        fetchShops: async function (key) {
            const data = await {
                _key: key
            }
            await this.$store.dispatch('fetchShopDetail', data)
            this.shops = this.getShopDetail
            if (this.shops.brand_id == 1) {
                this.brand = 'N牌'
            } else {
                this.brand = 'S牌'
            }
        },
        fetchUser: async function (key) {
            const data = await {
                _key: key
            }
            await this.$store.dispatch('fetchUserInfo', data)
            this.userInfo = await this.UserInfo
        },
        changeBack() {
            this.$emit('back')
        },
        editTabs: function () {
            this.$emit('editTabs', this.memberKey)
        }
    },
    mounted() {
        this.fetch()
    },
}
</script>

<style lang="scss" scoped>
.el-row {
    margin: 2%;

    font-weight: bold;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;

}
</style>
